// @ts-nocheck

import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

import { externalLinkOpen } from '../../../actions/externallink';
import useBindActionsCreator from '../../../hooks/useBindActionsCreator';
import useMergeProps from '../../../hooks/useMergeProps';
import RoutesRedirectionFactory from '../../../utils/routes/RoutesRedirectionFactory';
import { startGR } from '../actions/gr';
import GREnrollment from '../components/GREnrollment';
import useOpenGRView from '../hooks/useOpenGRView';
import selectGREnrollementProps from '../selectors/specifics/selectGREnrollementProps';
import { selectIsGREnabledAndNotForbidden } from '../selectors/specifics/selectGRRuntime';
import { GROperationUserStatuses } from '../types/user';

type GREnrollmentContainerProps = {
  className?: string;
};

const GREnrollmentContainer = (ownProps: GREnrollmentContainerProps) => {
  const dispatch = useDispatch();
  const selectedProps = useSelector(selectGREnrollementProps);
  const openGRView = useOpenGRView();

  const actions = useMemo(
    () => ({
      openExternalLink: externalLinkOpen,
    }),
    [],
  );

  const actionsProps = useBindActionsCreator(actions);

  const onEnroll = useCallback(() => {
    dispatch(startGR());
    openGRView();
  }, [dispatch, openGRView]);

  const otherProps = useMemo(() => ({ onEnroll }), [onEnroll]);

  const enhancedProps = useMergeProps({ ownProps, selectedProps, actionsProps, otherProps });

  const GROperationUserStatus = useSelector((state) => state.gr.user?.status);
  const isGREnabled = useSelector(selectIsGREnabledAndNotForbidden);

  if (isGREnabled) {
    if (GROperationUserStatus && GROperationUserStatus !== GROperationUserStatuses.OFF) {
      return <Redirect to={RoutesRedirectionFactory.getGRRoutePathname()} />;
    }

    return <GREnrollment {...enhancedProps} />;
  }

  return <Redirect to={RoutesRedirectionFactory.getHomeRoutePathname()} />;
};

export default GREnrollmentContainer;
